import request from "./../utils/request";

export function getAllLoginFormInputs() {
    return request.get(`/loginForms/get-all`);
}
export function updateLoginFormInput(data) {
    return request.post(`/loginForms/update`, { loginFormInput: data });
}

export function multiUpdateFormInputs(data) {
    return request.post(`/loginForms/multi-update`, { loginFormInputs: data });
}

export function createLoginFormInput(data) {
    return request.post(`/loginForms/create`, { loginForm: data });
}

export function findLoginFormInputById(id) {
    return request({
        url: `/loginForms/get`,
        method: "get",
        params: {
            id,
        },
    });
}

export function deleteLoginFormInputById(id) {
    return request({
        url: `/loginForms/delete`,
        method: "get",
        params: {
            id,
        },
    });
}
